var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "seatMap",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2718 3002",
    style: {
      enableBackground: "new 0 0 2718 3002"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            .st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n            .st1{fill:none;stroke:#000000;stroke-width:8;stroke-miterlimit:10;}\n            .st2{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n            .st3{fill:none;stroke:#000000;stroke-miterlimit:10;}\n          ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 794.6,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.4,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.1,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.9,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.6,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.4,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.1,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.1,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.9,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.6,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272.4,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.1,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1345.9,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1382.6,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1419.4,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1456.1,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.9,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1529.6,
    y: 41.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1683.4,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.2,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1756.9,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1793.7,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1830.4,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1867.2,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1903.9,
    y: 41.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-1-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 757.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 794.6,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.6,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.6,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1345.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1382.6,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1419.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1456.1,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1529.6,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1683.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.2,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1756.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1793.7,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1830.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1867.2,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1903.9,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1940.7,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.4,
    y: 110.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-2-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 757.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 794.6,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.6,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.6,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1345.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1382.6,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1419.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1456.1,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1529.6,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1683.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.2,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1756.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1793.7,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1830.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1867.2,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1903.9,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1940.7,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.4,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2014.2,
    y: 179.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-3-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 757.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 794.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 831.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 904.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 941.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 978.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1015.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1162.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1198.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1235.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1309.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1345.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1382.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1419.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1456.1,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1492.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1529.6,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1683.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1720.2,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1756.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1793.7,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1830.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1867.2,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1903.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1940.7,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.4,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2014.2,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2050.9,
    y: 248.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-4-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 317.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-5-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 386.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 386.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 386.2,
    className: "seat st0 seat-s",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 386.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 386.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-6-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 455.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 455.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-7-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 524.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 524.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-8-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 593.2,
    className: "seat st0 seat-a",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 593.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-9-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 662.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 662.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-10-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 731.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 731.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-11-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 800.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 800.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-12-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 869.2,
    className: "seat st0 seat-a hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 869.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-13-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 938.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 938.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-14-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1007.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1007.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-15-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.7,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.2,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.7,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.2,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1076.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1076.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1076.2,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1076.2,
    className: "seat st0 student hoge",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1076.2,
    className: "seat st0 student",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-16-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1237.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-17-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1306.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-18-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1375.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-19-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1444.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-20-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1513.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-21-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1582.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-22-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1651.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-23-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1720.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1720.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1720.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1720.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-24-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1789.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1789.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1789.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1789.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-25-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1858.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.7,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1180.5,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1217.2,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1254,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.7,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.5,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1364.2,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1401,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1437.7,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1474.5,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1511.2,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1548,
    y: 1858.1,
    className: "seat st0 crew",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1858.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1858.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-26-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.3,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.8,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.8,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.3,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.8,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.2,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.7,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 739.5,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.2,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 813,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.7,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.5,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 923.2,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 960,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 996.7,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1033.5,
    y: 1927.1,
    className: "seat st0 seat-b left",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1665.1,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1701.8,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1738.6,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1775.3,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1812.1,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1848.8,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1885.6,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1922.3,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1959.1,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1995.8,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2032.6,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2069.3,
    y: 1927.1,
    className: "seat st0 seat-b right",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2186.4,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2223.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2259.9,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2296.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2333.4,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2370.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2406.9,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2443.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2480.4,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2517.1,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2553.9,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2590.6,
    y: 1927.1,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-1-27-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2226,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-1-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2295,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-2-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1678.2,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1751.7,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1788.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.2,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1861.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1898.7,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1935.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1972.2,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2008.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2045.7,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2364,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-3-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1678.2,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1678.2,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1751.7,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1788.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.2,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1861.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1898.7,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1935.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1972.2,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2008.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2045.7,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2433,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-4-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1714.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1751.7,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1788.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1825.2,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1861.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1898.7,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1935.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1972.2,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2008.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2045.7,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2082.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2502,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-5-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.3,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2640,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-6-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.3,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2709,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-7-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.3,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2778,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-8-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1754.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1790.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1827.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1864.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1901.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1937.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1974.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2011.3,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2048.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2084.8,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2847,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-9-60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-11"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-14"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-15"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 819.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 856.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 929.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 966.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1175.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-26"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1212,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1248.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-28"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1285.5,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-29"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1322.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1359,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-31"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1395.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1432.5,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1469.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1506,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1542.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-36"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1680.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1717.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1754.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1790.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1827.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1864.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1901.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1937.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1974.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2011.3,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2048.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2084.8,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2254.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2291.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-51"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2328.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2364.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2401.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2438.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-55"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2475.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2511.9,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2548.6,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2585.4,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-59"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2622.1,
    y: 2916,
    className: "seat st0 seat-b",
    width: 36.7,
    height: 36.7,
    "data-seat_id": "s1-2-10-60"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 2654.3,
    y1: 2121,
    x2: 62.6,
    y2: 2121
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 1166.7,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.8,
    y: 1165.6,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1113.3,
    y: 1166.7,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1634.6,
    y: 1166.7,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2155.9,
    y: 1166.7,
    className: "st2",
    width: 441,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 947.9,
    y: 2572.5,
    className: "st2",
    width: 95.4,
    height: 14.8
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "598.8,2572.5 598.8,2806.1 947.9,2806.1 947.9,2572.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2782.4,
    x2: 947.9,
    y2: 2782.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2756.9,
    x2: 947.9,
    y2: 2756.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2731.4,
    x2: 947.9,
    y2: 2731.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2705.9,
    x2: 947.9,
    y2: 2705.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2680.4,
    x2: 947.9,
    y2: 2680.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 598.8,
    y1: 2654.9,
    x2: 947.9,
    y2: 2654.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1678.8,
    y: 2572.5,
    className: "st2",
    width: 95.4,
    height: 14.8
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "2123.3,2572.5 2123.3,2806.1 1774.2,2806.1 1774.2,2572.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2782.4,
    x2: 1774.2,
    y2: 2782.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2756.9,
    x2: 1774.2,
    y2: 2756.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2731.4,
    x2: 1774.2,
    y2: 2731.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2705.9,
    x2: 1774.2,
    y2: 2705.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2680.4,
    x2: 1774.2,
    y2: 2680.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 2123.3,
    y1: 2654.9,
    x2: 1774.2,
    y2: 2654.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 59.1,
    y: 2572.5,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.5,
    y: 2572.5,
    className: "st2",
    width: 441,
    height: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2217.9,
    y: 2572.5,
    className: "st2",
    width: 441,
    height: 18.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatSection1);
export default __webpack_public_path__ + "static/media/seatSection1.1faf524c2fddbbd8206104d4c4329b80.svg";
export { ForwardRef as ReactComponent };